/** @format */
import angular from 'angular';
import _ from 'lodash';
import { CourseUnitSearchComponent } from '../courseUnit/course-unit-search/course-unit-search.component';
import { ModuleSearchComponent } from '../module/module-search/module-search.component';
import { commonCourseUnitServiceModule } from '../service/courseUnit.service';
import { UniversitySelectEditorComponent } from '../university/university-select-editor/university-select-editor.component';
import prerequisiteSelectorTpl from './prerequisiteSelector.tpl.html';

export const prerequisiteSelectorModule = 'sis-components.prerequisites.prerequisiteSelector';

(function () {
    prerequisiteSelectorController.$inject = ['$timeout', 'commonCourseUnitService'];
    angular
        .module(prerequisiteSelectorModule, [
            'sis-components.date.yearRangeFilter',
            commonCourseUnitServiceModule,
            CourseUnitSearchComponent.downgrade.moduleName,
            ModuleSearchComponent.downgrade.moduleName,
            UniversitySelectEditorComponent.downgrade.moduleName,
        ])
        .component('prerequisiteSelector', {
            template: prerequisiteSelectorTpl,
            bindings: {
                prerequisiteIndex: '<',
                onSelect: '<',
                type: '<',
            },
            controller: prerequisiteSelectorController,
        });

    function prerequisiteSelectorController($timeout, commonCourseUnitService) {
        // We don't need to define university or onUniversityChange callback because we can't switch between course-unit-search and
        // module-search inside single instance of this component.
        const $ctrl = this;
        $ctrl.courseUnitService = commonCourseUnitService;
        $ctrl.handleSelection = selection => {
            $timeout(() => {
                $ctrl.onSelect($ctrl.prerequisiteIndex, _.get(selection, 'groupId'));
            });
        };
        $ctrl.universityOnChange = function (university) {
            // We assume that course unit or module search will clear selected object for us if needed (with callback)
            $ctrl.university = university;
        };
    }
})();
